<template>
  <div class="chat">
    <!-- <pre>{{ formParamSRSt }}</pre> -->
    <div v-if="hasVariants" class="wa-preview-variant-tabs">
      <span class="wa-preview-variant-label">Pratinjau varian:</span>
      <button
        v-for="(variant, index) in activeVariants"
        :key="variant.variant_code || index"
        type="button"
        class="wa-preview-variant-tab"
        :class="{ 'is-active': selectedVariantIndex === index }"
        @click.prevent="pilihVarian(index)"
      >
        Content {{ variant.variant_code || index + 1 }}
      </button>
    </div>
    <div class="chat-box">
      <div class="chats">
        <div class="chat chat-right">
          <div class="chat-body">
            <div class="chat-bubble">
              <div class="chat-content">
                <div class="chat-img-group clearfix" v-if="
                  previewParam.message.message_type == 'image' &&
                  previewParam.interactive_message_type != 'list_text'
                ">
                  <a class="chat-img-attach" href="javascript:void(0)">
                    <img style="max-height: 200px" alt :src="previewParam.message.file_url" />
                  </a>
                </div>
                <ul class="attach-list wa-document-preview" v-if="
                  previewParam.message.message_type == 'document' &&
                  previewParam.interactive_message_type != 'list_text' &&
                  previewParam.message.file_url
                ">
                  <li>
                    <span class="wa-document-icon">
                      <i class="fa fa-file-text-o"></i>
                    </span>
                    <span class="wa-document-copy">
                      <a
                        :href="previewParam.message.file_url"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ documentFileName(previewParam.message.file_url) }}
                      </a>
                      <small>Dokumen</small>
                    </span>
                  </li>
                </ul>
                <ul class="attach-list" v-if="
                  previewParam.message.message_type == 'video' &&
                  previewParam.interactive_message_type != 'list_text'
                ">
                  <li v-if="previewParam.message.file_url">
                    <div class="video-preview-wrapper mb-2">
                      <video controls width="100%" max-width="400"
                        style="border-radius: 8px; max-height: 250px; background-color: #000;">
                        <source :src="previewParam.message.file_url" type="video/mp4" />
                        Browser Anda tidak mendukung tag video HTML5.
                      </video>
                    </div>
                    <!-- <div>
                      <i class="fa fa-file"></i>
                      <a :href="previewParam.message.file_url" target="_blank">
                        Buka Video di Tab Baru
                      </a>
                    </div> -->
                  </li>
                </ul>
                <p v-html="messageFilter(previewParam.message.text)" v-if="previewParam.message.text != ''"
                  v-linkified></p>
                <span v-html="messageFilter(previewParam.footer_message)" class="text-muted" style="font-size: 10px" v-linkified v-if="
                  previewParam.footer_message_status == true &&
                  previewParam.interactive_message_status == true
                "></span>

                <template v-if="previewParam.interactive_message_status == true">
                  <div v-if="
                    previewParam.interactive_message_type == 'text_reply'
                  ">
                    <!-- {{ previewParam.buttons }} -->
                    <!-- <div class="text-left" v-for="(auto_reply_button_id, idx) in previewParam.buttons" :key="idx" v-if="auto_reply_button_id!=''">
                    <span v-html="getTextReplyLabelById(auto_reply_button_id, idx)"></span>
                  </div> -->
                    <div class="text-left">
                      <!-- <ol>
                      <li v-for="(auto_reply_button_id, idx) in previewParam.buttons" :key="idx" v-if="auto_reply_button_id!=''">
                       {{ auto_reply_button_id.button_text }}
                      </li>
                    </ol> -->
                      <div v-html="getTextReplyLabelByIdV2()"></div>
                    </div>
                  </div>
                </template>
              </div>

              <div class="chat-content" v-if="
                (previewParam.message.message_type == 'image' ||
                  previewParam.message.message_type == 'document') &&
                previewParam.interactive_message_type == 'list_text'
              ">
                <div class="chat-img-group clearfix" v-if="previewParam.message.message_type == 'image'">
                  <a class="chat-img-attach" href="javascript:void(0)">
                    <img style="max-height: 200px" alt :src="previewParam.message.file_url" />
                  </a>
                </div>
                <ul class="attach-list wa-document-preview" v-if="
                  previewParam.message.message_type == 'document' &&
                  previewParam.message.file_url
                ">
                  <li>
                    <span class="wa-document-icon">
                      <i class="fa fa-file-text-o"></i>
                    </span>
                    <span class="wa-document-copy">
                      <a
                        :href="previewParam.message.file_url"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ documentFileName(previewParam.message.file_url) }}
                      </a>
                      <small>Dokumen</small>
                    </span>
                  </li>
                </ul>
                <ul class="attach-list" v-if="previewParam.message.message_type == 'video'">
                  <li v-if="previewParam.message.file_url">
                    <div class="video-preview-wrapper mb-2">
                      <video controls width="100%" max-width="400"
                        style="border-radius: 8px; max-height: 250px; background-color: #000;">
                        <source :src="previewParam.message.file_url" type="video/mp4" />
                        Browser Anda tidak mendukung tag video HTML5.
                      </video>
                    </div>
                    <!-- <div>
                      <i class="fa fa-file"></i>
                      <a :href="previewParam.message.file_url" target="_blank">
                        Buka Video di Tab Baru
                      </a>
                    </div> -->
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatWhatsAppText } from "@/utils/whatsappFormat";

export default {
  components: {},
  props: {
    value: {
      type: Object,
      default: false,
    },
    buttonsRows: {
      type: Array,
      default: () => [{ button_text: "" }],
    },
    linkRows: {
      type: Array,
    },
    textReplyRows: {
      type: Array,
    },
    formatter: {
      type: Function,
      default: null,
    },
    showVariants: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      selectedVariantIndex: 0,
    };
  },
  watch: {
    activeVariants(value) {
      if (!value.length) {
        this.selectedVariantIndex = 0;
        return;
      }

      if (this.selectedVariantIndex >= value.length) {
        this.selectedVariantIndex = 0;
      }
    },
  },
  computed: {
    formParamSRSt: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    activeVariants() {
      const form = this.formParamSRSt || {};
      return Array.isArray(form.variants)
        ? form.variants.filter((variant) => variant && !variant.deleted)
        : [];
    },
    hasVariants() {
      const form = this.formParamSRSt || {};
      return (
        this.showVariants &&
        !!form.ab_testing_enabled &&
        this.activeVariants.length > 0
      );
    },
    previewParam() {
      const form = this.formParamSRSt || {};

      if (!this.hasVariants) {
        return form;
      }

      const variant =
        this.activeVariants[this.selectedVariantIndex] || this.activeVariants[0];

      if (!variant) {
        return form;
      }

      const mainMessage = form.message || {};
      const variantMessage = variant.message || {};

      return Object.assign({}, form, {
        message: Object.assign({}, mainMessage, variantMessage),
        is_custom_url:
          typeof variant.is_custom_url !== "undefined"
            ? !!variant.is_custom_url
            : !!form.is_custom_url,
        interactive_message_status:
          typeof variant.interactive_message_status !== "undefined"
            ? !!variant.interactive_message_status
            : !!form.interactive_message_status,
        interactive_message_type:
          variant.interactive_message_type ||
          form.interactive_message_type ||
          "",
        buttons: Array.isArray(variant.buttons)
          ? variant.buttons
          : form.buttons || [],
        footer_message_status:
          typeof variant.footer_message_status !== "undefined"
            ? !!variant.footer_message_status
            : !!form.footer_message_status,
        footer_message:
          typeof variant.footer_message !== "undefined"
            ? variant.footer_message
            : form.footer_message || "",
        list_button_text: variant.list_button_text || form.list_button_text || "Options",
      });
    },
    // formParamSRSt() {
    //   return this.$store.state.omniwa.broadcastParamSt;
    // }
  },
  methods: {
    getTextReplyLabelByIdV2() {
      var number = 1;
      let htmlData = "";
      const buttons = Array.isArray(this.previewParam.buttons)
        ? this.previewParam.buttons
        : [];
      const btn = buttons.filter((button) => button && button.id != "");
      btn.forEach((button) => {
        const titleLabel =
          button.button_text || "Text Reply (" + button.id + ")";
        htmlData += "<br />" + number + ". " + titleLabel + "";
        number++;
      });
      return htmlData;
    },
    getTextReplyLabelById(id, idx) {
      let arr = this.textReplyRows.find((msgs) => msgs.id === id);
      if (
        arr != null &&
        typeof arr.title != "undefined" &&
        typeof arr != "undefined"
      ) {
        return idx + 1 + ". " + arr.title;
      } else {
        return "";
      }
    },
    getButtonLabelById(id) {
      let arr = this.buttonsRows.find((msgs) => msgs.id === id);
      if (arr != null && typeof arr.button_text != "undefined") {
        return arr.button_text;
      } else {
        return "";
      }
    },
    getLinkLabelById(id) {
      let arr = this.linkRows.find((msgs) => msgs.id === id);
      if (arr != null && typeof arr.button_text != "undefined") {
        if (arr.button_type == "call") {
          return '<i class="fa fa-phone"></i> ' + arr.button_text;
        } else {
          return '<i class="fa fa-external-link"></i> ' + arr.button_text;
        }
      } else {
        return "";
      }
    },
    pilihVarian(index) {
      this.selectedVariantIndex = index;
    },
    documentFileName(url) {
      if (!url) {
        return "Dokumen";
      }

      try {
        const cleanUrl = String(url).split("?")[0].split("#")[0];
        const fileName = cleanUrl.substring(cleanUrl.lastIndexOf("/") + 1);
        return decodeURIComponent(fileName) || "Dokumen";
      } catch (error) {
        return "Dokumen";
      }
    },
    messageFilter(message) {
      if (!message) return "";

      if (typeof this.formatter === "function") {
        return this.formatter(message);
      }

      return formatWhatsAppText(message);
    },
    messageFilterOld(message) {
      return message.replace(/\r?\n/g, "<br />");
    },
  },
  async created() { },
  beforeDestroy() { },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left",
        },
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add",
};
</script>

<style>
.wa-preview-variant-tabs {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  padding: 8px 10px;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 10px;
}

.wa-preview-variant-label {
  margin-right: 2px;
  color: #667085;
  font-size: 11px;
  font-weight: 700;
}

.wa-preview-variant-tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  padding: 0 11px;
  color: #667085;
  background: #f8fafc;
  border: 1px solid #e4eaf2;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  transition: background-color 0.18s ease, color 0.18s ease,
    border-color 0.18s ease;
}

.wa-preview-variant-tab:hover,
.wa-preview-variant-tab.is-active {
  color: #9a5d00;
  background: #fff7e8;
  border-color: #f6d49b;
}

.wa-preview-variant-tab.is-active {
  color: #ffffff;
  background: #f39c12;
  border-color: #f39c12;
}

.chat-bubble .wa-document-preview {
  padding: 0;
  margin: 0 0 8px;
  list-style: none;
}

.chat-bubble .wa-document-preview li {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 9px 10px;
  background: #ffffff;
  border: 1px solid #e4e7ec;
  border-radius: 9px;
}

.chat-bubble .wa-document-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  color: #b36b00;
  background: #fff7e8;
  border-radius: 8px;
  font-size: 15px;
}

.chat-bubble .wa-document-copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.chat-bubble .wa-document-copy a {
  overflow: hidden;
  color: #344054;
  font-size: 11px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chat-bubble .wa-document-copy small {
  color: #98a2b3;
  font-size: 9px;
}

.chat-bubble .wa-format-code {
  display: inline;
  padding: 1px 5px;
  color: #344054;
  background: #f2f4f7;
  border: 1px solid #e4e7ec;
  border-radius: 4px;
  font-family: Consolas, Monaco, "Courier New", monospace;
  font-size: 0.92em;
  white-space: pre-wrap;
  word-break: break-word;
}

.chat-bubble .chat-img-group img {
  display: block;
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 220px;
  object-fit: contain;
  border-radius: 8px;
}

.chat-bubble .video-preview-wrapper video {
  display: block;
  width: 100%;
  max-width: 400px;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
}

.chat-bubble strong {
  font-weight: 800;
}

.chat-bubble em {
  font-style: italic;
}

.chat-bubble del {
  text-decoration: line-through;
}
</style>


// WEBPACK FOOTER //
// src/views/broadcast/componentsV2/Forms/preview.vue